export const texts = {
  menu: 'Menú',
  casino: 'Casino',
  search: 'Buscar',
  sports: 'Deportes',
  login: 'Ingresar',
  profile: 'Perfil',
}
